module.exports = __webpack_public_path__ + "img/app-ysm.3556bf75.png";